import { cn } from "@/utils";
import { useEffect, useRef, useState } from "react";

interface Props {
  tabs: TabItem[];
  keyActive?: number;
  onTabChange?: (key: number) => void;
}

export interface TabItem {
  label: string | React.ReactNode;
  key: number;
  children: string | number | React.ReactNode;
  disabled?: boolean;
}

export const Tabs = ({ tabs, keyActive = 0, onTabChange }: Props) => {
  const [active, setActive] = useState(keyActive);
  const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);
  const inkRef = useRef<HTMLDivElement>(null);

  // Update keyActive from props
  useEffect(() => {
    setActive(keyActive);
  }, [keyActive]);

  const firstTabActiveKey = tabs.findIndex((tab) => !tab.disabled);

  useEffect(() => {
    if (tabs.find((tab) => tab.key === keyActive)?.disabled) {
      setActive(firstTabActiveKey);
    }
  }, []);

  useEffect(() => {
    const activeTab = tabsRef.current[active];
    if (activeTab && inkRef.current) {
      const { offsetLeft, offsetWidth } = activeTab;
      inkRef.current.style.left = offsetLeft + "px";
      inkRef.current.style.width = offsetWidth + "px";
    }
  }, [active]);

  return (
    <>
      <div className="relative border-b border-gray-300">
        <div className="flex space-x-10 h-12 items-center">
          {tabs.map((tab, i) => (
            <button
              key={tab.key}
              disabled={tab.disabled || false}
              ref={(el) => {
                tabsRef.current[i] = el;
              }}
              onClick={() => {
                setActive(i);
                onTabChange?.(i);
              }}
              className={cn(
                "py-3 leading-5.5 transition-colors text-sm cursor-pointer hover:text-cyan",
                active === i
                  ? "text-cyan font-semibold"
                  : "text-auro_metal_saurus",
                tab.disabled && "opacity-50 cursor-not-allowed"
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Ink bar */}
        <div
          ref={inkRef}
          className="absolute -bottom-[1px] h-[2px] bg-cyan transition-all duration-300"
        ></div>
      </div>
      {tabs[active].children}
    </>
  );
};
